"use client";

import {
  ApplicationInsights,
  DistributedTracingModes,
} from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

let instance: ApplicationInsights | null = null;

function getCookie(name: string) {
  return (
    document.cookie
      .split("; ")
      .find((row) => row.startsWith(name + "="))
      ?.split("=")[1] ?? null
  );
}

export function initAppInsights(connectionString: string, roleName: string) {
  if (typeof window === "undefined") return null;

  if (instance) {
    // console.log("Reusing existing AppInsights instance");
    return instance;
  }
  // console.log("Creating new AppInsights instance");

  const reactPlugin = new ReactPlugin();

  const appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
      extensions: [reactPlugin],
    },
  });

  appInsights.loadAppInsights();

  let sessionId =
    getCookie("x-session-id") || sessionStorage.getItem("x-session-id");

  if (!sessionId) {
    sessionId = crypto.randomUUID();
    // console.log("Generated new session ID:", sessionId);
  } else {
    // console.log("Reusing existing session ID:", sessionId);
  }

  appInsights.context.sessionManager.automaticSession.id = sessionId;

  sessionStorage.setItem("x-session-id", sessionId);
  document.cookie = `x-session-id=${sessionId}; path=/; SameSite=Lax`;

  // console.log("Cookie value:", getCookie("x-session-id"));
  // console.log(
  //   "SessionStorage value:",
  //   sessionStorage.getItem("x-session-id"),
  // );

  appInsights.addTelemetryInitializer((env) => {
    env.tags = env.tags || {};
    env.tags["ai.cloud.role"] = roleName;
  });

  instance = appInsights;

  return instance;
}
